import {
  clock,
  infoCircle,
  messageDelivered,
  messageRead,
  messageSent,
} from "../../../utility-functions/assetLoader";
import classes from "./Message.module.css";

const Message = ({ time, status, message }) => {
  return (
    <>
      <div
        style={{
          flexDirection: status === "RECEIVED" ? "row-reverse" : "row",
        }}
        className={classes.container}
      >
        {status === "SENT"
          ? messageSent(16, 16)
          : status === "DELIVERED"
            ? messageDelivered(16, 16)
            : status === "READ"
              ? messageRead(16, 16)
              : status === "QUEUED"
                ? clock(16, 16)
                : ""}
        <span>{time}</span>

        <div
          style={{
            margin: status !== "RECEIVED" ? "0 0 0 8px" : "0 8px 0 0",
            background: status === "RECEIVED" ? "#FFFFFF" : "#f1fcf4",
            border: status === "FAILED" ? "1px solid #E22D20" : "",
          }}
        >
          <p>{message}</p>
        </div>
      </div>
      {status === "FAILED" ? (
        <div className={classes.failed}>
          {infoCircle("#E22D20", 20, 20)}
          <span>Sending failed. </span>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Message;
